import queryString from 'query-string';

import { Col, Divider, Logo, Row } from '$HVUI';
import Button from '$Molecules/Buttons/Button';

const CovidLanding = () => {
    const query = queryString.parse(window.location.search);
    const { orgID = 12926 } = query;
    return (
        <div>
            <Row>
                <Col span={24}>
                    <Logo style={{ height: '20px' }} />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Divider style={{ margin: '8px' }} />
                </Col>
            </Row>
            <Row style={{ margin: '16px auto 24px auto' }}>
                <Col span={24}>
                    <h1 style={{ fontSize: '150%' }}>COVID-19 Testing</h1>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <p>Drive-Thru screening test approved by FDA and CDC.</p>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <p>Priority is given to persons at highest risk.</p>
                </Col>
            </Row>
            <Row style={{ margin: '16px auto 96px auto' }}>
                <Col span={18} offset={3}>
                    <Button
                        element="a"
                        onClick={() => window.location.assign(`/reg/${orgID}`)}
                        text="Register"
                    />
                </Col>
            </Row>
            <Row
                style={{
                    position: 'absolute',
                    bottom: '32px',
                    left: '0',
                    width: '100%'
                }}
            >
                <Col span={8} offset={2}>
                    <a href="/faq/">FAQs</a>
                </Col>
                <Col span={8} offset={4}>
                    <a href="/faq/">About Us</a>
                </Col>
            </Row>
        </div>
    );
};

export default CovidLanding;
